// The backend returns a structured NestJS error body ({ message, statusCode }) — fall back to the
// raw axios error message if the response doesn't have one (e.g. a network failure).
export function errorMessage(err) {
  return err.response?.data?.message || err.message;
}
